﻿
(() => {
    angular.module('fliptoWeb')
        .controller('WebisodeFuelCtrl', ['$http', '$stateParams', '$window', 'ApiService',
            function ($http, $stateParams, $window, ApiService) {
            var vm = this;

            vm.socialShareTitle = "";
            vm.socialShareContent = "";
            vm.socialFeaturedImage = null;

            
            vm.shareFacebook = () => {                
                //array of key/value objects
                var options = new Array();
                options.push('app_id=' + encodeURIComponent($window.SOCIAL_CONFIGURATION.facebookApiKey));
                options.push('display=' + encodeURIComponent('popup'));
                options.push('href=' + encodeURIComponent($window.location.href.replace($window.location.host, "www.flip.to")));
                //We trigger a new window with the Twitter dialog, in the middle of the page
                window.open($window.SOCIAL_CONFIGURATION.URL_DIALOG_BASE + 'share?' + options.join('&'), 'facebookWindow', 'height=266, width=550, top=' + ($window.innerHeight / 2 - 225) + ', left=' + $window.innerWidth / 2 + ',' +
                    ' toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            }

            vm.shareTwitter = ()=> {
                //We get the URL of the link
                var loc = $window.location.href;
                //We get the title of the link
                var title = vm.socialShareTitle;

                //array of key/value objects
                var options = new Array();
                options.push('url=' + encodeURIComponent(loc));
                options.push('text=' + encodeURIComponent(title));
                options.push('via=' + encodeURIComponent('fliptocom'));

                //We trigger a new window with the Twitter dialog, in the middle of the page
                window.open('https://twitter.com/intent/tweet?' + options.join('&'),
                    'twitterWindow',
                    'height=266, width=550, top=' + ($window.innerHeight / 2 - 225) + ', left=' + $window.innerWidth / 2 + ',' +
                    ' toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            }

            vm.shareLinkedIn = () => {
                //We get the URL of the link
                var loc = $window.location.href;
                //We get the title of the link
                var title = vm.socialShareTitle;

                //array of key/value objects
                var options = new Array();
                options.push('min=' + true);
                options.push('url=' + encodeURIComponent(loc));
                options.push('title=' + encodeURIComponent(title));
                options.push('summary=' + encodeURIComponent(vm.socialShareContent));

                //We trigger a new window with the Twitter dialog, in the middle of the page
                window.open('https://www.linkedin.com/shareArticle?' + options.join('&'),
                    'linkedInWindow',
                    'height=530, width=550, top=' + ($window.innerHeight / 2 - 225) + ', left=' + $window.innerWidth / 2 + ',' +
                    ' toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
            }


            vm.submit = () => {
                this.errorMessage = "";
                this.processingRequest = true;
                
                ApiService.WebisodeFuelSubscribe(vm.email)
                    .then(function (response) {
                        if (response.data.Success) {
                            alert("Your message is on its way!");
                            vm.hasBeenSubmitted = true;
                        } else {
                            vm.errorMessage = response.data.Message;
                        }

                        vm.processingRequest = false;
                    });
            }
            
        }]);
})()
